import './OrganizationsTable.scss';
import { AsyncStateNotification } from '@ui/notifications';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { getOrganizationTableColumns } from './OrganizationsTableColumns';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { SonarTable } from '@ui/SonarTable';
import React, { useMemo } from 'react';
import { useAction, useCurrentUser, useInterval, useOrganizations, useSalesforceOrganizations, useUpdateOrganization } from '@hooks';
const getRowKey = (organization) => organization.id;
export const OrganizationsTable = () => {
    const organizations = useSalesforceOrganizations();
    const { isReadOnly } = useCurrentUser();
    const getAllOrganizations = useAction(useOrganizations.loadAction);
    useInterval(getAllOrganizations, 5000);
    const columns = useMemo(() => getOrganizationTableColumns(isReadOnly), [isReadOnly]);
    if (!(organizations === null || organizations === void 0 ? void 0 : organizations.length)) {
        return React.createElement(LoadingSpinner, { spinning: true });
    }
    return (React.createElement("div", { id: 'organizations-table' },
        React.createElement(SonarTable, { columns: columns, dataSource: organizations, pagination: false, rowKey: getRowKey, scroll: { x: 'max-content' }, size: 'small' }),
        React.createElement(AsyncStateNotification, { errored: COPY_GENERIC.UNHANDLED_ERROR, failed: COPY_GENERIC.UNHANDLED_ERROR, stateSelector: useUpdateOrganization.selectors.state })));
};
